import {
  AppContext,
  getTranslatedText,
  isAuthorised,
  DeleteModal,
  getLokaliseKeyByProduct,
  useProduct
} from '@nile/components';
import {
  ActionList,
  DisplayText,
  Button,
  Popover,
  TextStyle
} from '@superops/ui-design-system';
import styled from 'styled-components';
import React, { useCallback, useContext, useState } from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

function ActionListInPopoverTableRow(props) {
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const appContext = useContext(AppContext);
  const { user } = appContext;
  const currentProduct = useProduct();
  const reference = user?.role?.roleFeatureList || [];
  const isDeleteAuthorised = isAuthorised(reference, 'employees.delete');
  const isForgetAuthorised = isAuthorised(reference, 'employees.delete');
  const isAddAuthorised = isAuthorised(reference, 'employees.add');
  const { intl, cell, column } = props;
  const isSameUser = cell.row.original.userId !== user.userId;
  const items = [];
  const modalActivator = (
    <div>
      <div className="flex g10">
        <div className="fx center" style={{ marginRight: '5px' }}>
          <SVGIcon name="Delete" color="#E02020" />
        </div>
        <div>
          <TextStyle variation="negative">
            {getTranslatedText(intl, 'common.delete')}
          </TextStyle>
          <DisplayText size="small">
            {getTranslatedText(intl, 'admin.employee.delete.desc')}
          </DisplayText>
        </div>
      </div>
    </div>
  );
  const forgetModalActivator = (
    <div>
      <div className="flex g10">
        <div className="fx center" style={{ marginRight: '5px' }}>
          <SVGIcon name="Broom" color="#E02020" />
        </div>
        <div>
          <TextStyle variation="negative">
            {getTranslatedText(intl, 'admin.employee.forget')}
          </TextStyle>
          <DisplayText size="small">
            {getTranslatedText(intl, 'admin.employee.forget.desc')}
          </DisplayText>
        </div>
      </div>
    </div>
  );

  if (isSameUser && isDeleteAuthorised) {
    items.push({
      id: 'deleteEmployee',
      content: (
        <DeleteModal
          id="deleteRole"
          variant="confirmation"
          sectioned={false}
          modalActivator={modalActivator}
          description={getTranslatedText(
            intl,
            getLokaliseKeyByProduct(currentProduct, 'deleteEmployeeDescription')
          )}
          handleDeleteConfirmation={() => {
            column?.actions?.delete(props.cell?.row?.original);
            toggleActive();
          }}
          title={getTranslatedText(
            intl,
            getLokaliseKeyByProduct(currentProduct, 'deleteEmployeeTitle')
          )}
        />
      ),
      onAction: () => {}
    });
  }

  if (isSameUser && isForgetAuthorised) {
    items.push({
      id: 'forgetEmployee',
      // content: getTranslatedText(intl, 'admin.employee.delete'),
      content: (
        <DeleteModal
          id="forgetRole"
          variant="confirmation"
          sectioned={false}
          modalActivator={forgetModalActivator}
          description={getTranslatedText(
            intl,
            getLokaliseKeyByProduct(currentProduct, 'forgotEmployeeDescription')
          )}
          handleDeleteConfirmation={() => {
            column?.actions?.delete(props.cell?.row?.original, true);
            toggleActive();
          }}
          title={getTranslatedText(
            intl,
            getLokaliseKeyByProduct(currentProduct, 'forgotEmployeeTitle')
          )}
        />
      ),
      onAction: () => {}
    });
  }

  const activator =
    cell.row.original.userId !== user.userId ? (
      <>
        {isDeleteAuthorised || isForgetAuthorised ? (
          <span onClick={toggleActive} className="fx jctr ptr">
            <SVGIcon name="Menu" />
          </span>
        ) : (
          <></>
        )}
      </>
    ) : (
      <></>
    );
  return (
    <div>
      <Popover active={active} activator={activator} onClose={toggleActive}>
        <ActionList items={items} />
      </Popover>
    </div>
  );
}

export default injectIntl(ActionListInPopoverTableRow);
